import React from "react";
import PropTypes from "prop-types";
import AutoCompleteSelect from "../../../components/AutoCompleteSelect/AutoCompleteSelect";
import SimpleDateRangePicker from "../../../components/SimpleDateRangePicker/SimpleDateRangePicker";
import { CUSTOM } from "../../../helpers/constant/filters";
import { Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    errorText: {
        color: "red",
        marginTop: "5px"
    }
}));

const FilterSelections = ({ dataLists, selectionAddActions, filterValues }) => {
    const {
        handleProviderChange,
        handleCountryChange,
        handlePublisherChange,
        changeSelectedInterval,
        changeSelectedLowServerThresholdCount,
        setLowServerCount,
        handleGroupByChange,
        handleRuleIdChange,
        handleTagIdChange,
        handleAdvertiserLinkGroupIdChange,
        handleDateChange,
        handleTagTypeChange,
        handleTrafficSourceChange,
        handlePlatformChange,
        handleSearchEngineChange,
        changeSelectedPeriod,
        handleChannelsChange,
        handleRemarkChange,
        setMissingSubids,
        setReportByTrafficQuality,
        handleInputChange,
        handleKeyDown,
        clearInputValue
    } = selectionAddActions;

    const {
        publishers,
        providers,
        countries,
        intervals,
        lowServerThresholdCounts,
        groupByList,
        tagIds,
        advertiserLinkGroupIds,
        ruleIds,
        tagTypes,
        trafficSources,
        platforms,
        searchEngines,
        channels,
        periods,
        remarks,
        inputValue,
        pubLinkLoading
    } = dataLists;
    const {
        selectedProviders,
        selectedCountries,
        selectedPublishers,
        fromDate,
        toDate,
        selectedInterval,
        selectedLowServerThresholdCount,
        selectedGroupBy,
        selectedRuleIds,
        selectedTagIds,
        selectedAdvertiserLinkGroupIds,
        selectedTagTypes,
        selectedTrafficSources,
        selectedPlatforms,
        selectedSearchEngines,
        selectedChannels,
        selectedPeriod,
        selectedRemark,
        missingSubids,
        reportByTrafficQuality,
        lowServerCount,
        pubLinkIdError
    } = filterValues;

    const classes = useStyles();

    function handleMissingSubidCheck() {
        setMissingSubids(!missingSubids);

        let existingGroupBy = [...selectedGroupBy];
        let existingRemarks = [...selectedRemark];
        const groupByToAdd = ['channel', 'advertiser_id', 'country', 'remarks']
        const remarksToAdd = [2, 3, 4, 5]


        if (!missingSubids) {
            groupByToAdd.forEach(group => {
                if (!existingGroupBy.includes(group)) {
                    existingGroupBy.push(group);
                }
            })

            remarksToAdd.forEach(remark => {
                if (!existingRemarks.includes(remark)) {
                    existingRemarks.push(remark);
                }
            })
        } else {
            existingGroupBy = existingGroupBy.filter(group => !groupByToAdd.includes(group));
            existingRemarks = existingRemarks.filter(remark => !remarksToAdd.includes(remark));
        }

        handleRemarkChange(existingRemarks);
        handleGroupByChange(existingGroupBy);
    }

    function handleReportByTrafficQualityToggle() {
        setReportByTrafficQuality(!reportByTrafficQuality);
        let existingGroupBy = [...selectedGroupBy];
        const groupByToAdd = ['channel', 'advertiser_id', 'advertiser_channel_id', 'country', 'publisher_id', 'publisher_channel_id', 'tq']
        if (!reportByTrafficQuality) {
            groupByToAdd.forEach(group => {
                if (!existingGroupBy.includes(group)) {
                    existingGroupBy.push(group);
                }
            })
        } else {
            existingGroupBy = existingGroupBy.filter(group => !groupByToAdd.includes(group));
        }
        handleGroupByChange(existingGroupBy);
    }

    function handleLowServerCountCheckToggle() {
        setLowServerCount(!lowServerCount);
    }

    return (
        <div className="dashboard-report__filters__filter-selects">
            <AutoCompleteSelect
                selected={selectedPeriod}
                data={periods}
                handleChange={changeSelectedPeriod}
                label={"Period"}
                showValueInLabel={false}
                enableMultiple={false}
            />
            {selectedPeriod === CUSTOM && (
                <SimpleDateRangePicker
                    startDate={fromDate ? fromDate : null}
                    endDate={toDate ? toDate : null}
                    handleDateChange={handleDateChange}
                />
            )}
            <AutoCompleteSelect
                selected={selectedInterval}
                data={intervals}
                handleChange={changeSelectedInterval}
                label={"Interval"}
                showValueInLabel={false}
                enableMultiple={false}
            />
            <AutoCompleteSelect
                selected={selectedProviders}
                data={providers}
                handleChange={handleProviderChange}
                label={"Advertisers"}
                showValueInLabel={true}
                enableMultiple={true}
                withDotsForStatus={true}
            />
            <AutoCompleteSelect
                selected={selectedChannels}
                data={channels}
                handleChange={handleChannelsChange}
                label={"Channel"}
                showValueInLabel={false}
                enableMultiple={true}
                withDotsForStatus={false}
            />
            <AutoCompleteSelect
                selected={selectedPublishers}
                data={publishers}
                handleChange={handlePublisherChange}
                label={"Publisher"}
                showValueInLabel={true}
                enableMultiple={true}
                withDotsForStatus={true}
            />
            <AutoCompleteSelect
                selected={selectedRuleIds}
                data={ruleIds}
                handleChange={handleRuleIdChange}
                label={"Rule ID"}
                showValueInLabel={false}
                enableMultiple={true}
                withDotsForStatus={true}
            />
            <div>
                <AutoCompleteSelect
                    error={pubLinkIdError ? true : false}
                    selected={selectedTagIds}
                    data={tagIds}
                    handleChange={handleTagIdChange}
                    label={"Pub Link ID"}
                    showValueInLabel={false}
                    enableMultiple={true}
                    withDotsForStatus={true}
                    triggerOnKeyDown={true}
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    inputValue={inputValue}
                    loading={pubLinkLoading}
                    clearInputValue={clearInputValue}
                />
                {pubLinkIdError && (
                    <div className={classes.errorText}>
                        <small>{pubLinkIdError}</small>
                    </div>
                )}
            </div>
            <AutoCompleteSelect
                selected={selectedAdvertiserLinkGroupIds}
                data={advertiserLinkGroupIds}
                handleChange={handleAdvertiserLinkGroupIdChange}
                label={"Adv link group ID"}
                showValueInLabel={false}
                enableMultiple={true}
                withDotsForStatus={true}
            />

            <AutoCompleteSelect
                selected={selectedPlatforms}
                data={platforms}
                handleChange={handlePlatformChange}
                label={"Platform"}
                showValueInLabel={true}
                enableMultiple={true}
                withDotsForStatus={false}
            />
            <AutoCompleteSelect
                selected={selectedSearchEngines}
                data={searchEngines}
                handleChange={handleSearchEngineChange}
                label={"Search Engine"}
                showValueInLabel={true}
                enableMultiple={true}
                withDotsForStatus={false}
            />
            <AutoCompleteSelect
                selected={selectedTagTypes}
                data={tagTypes}
                handleChange={handleTagTypeChange}
                label={"Traffic Type"}
                showValueInLabel={true}
                enableMultiple={true}
                withDotsForStatus={false}
            />
            <AutoCompleteSelect
                selected={selectedTrafficSources}
                data={trafficSources}
                handleChange={handleTrafficSourceChange}
                label={"Traffic Source"}
                showValueInLabel={true}
                enableMultiple={true}
                withDotsForStatus={false}
            />
            <AutoCompleteSelect
                selected={selectedCountries}
                data={countries}
                handleChange={handleCountryChange}
                label={"Geo"}
                showValueInLabel={true}
                enableMultiple={true}
            />
            <AutoCompleteSelect
                selected={selectedRemark}
                data={remarks}
                handleChange={handleRemarkChange}
                label={"Remarks"}
                showValueInLabel={true}
                enableMultiple={true}
            />
            <AutoCompleteSelect
                selected={selectedGroupBy}
                data={groupByList}
                handleChange={handleGroupByChange}
                label={"Group By"}
                showValueInLabel={false}
                enableMultiple={true}
            />
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <Checkbox
                    checked={lowServerCount}
                    onChange={handleLowServerCountCheckToggle}
                />

                Filterout records with server search count lower than

                <div style={{ minWidth: 20, flex: "0 0 auto" }}>
                    <AutoCompleteSelect
                        selected={selectedLowServerThresholdCount}
                        data={lowServerThresholdCounts}
                        handleChange={changeSelectedLowServerThresholdCount}
                        label={""}
                        placeholder={""}
                        showValueInLabel={false}
                        enableMultiple={false}
                    />
                </div>
            </div>
            <div>
                <Checkbox
                    checked={missingSubids}
                    onChange={handleMissingSubidCheck}
                />
                Missing Channels
            </div>
            <div>
                <Checkbox
                    checked={reportByTrafficQuality}
                    onChange={handleReportByTrafficQualityToggle}
                />
                Group report by traffic quality
            </div>
        </div>
    );
};

FilterSelections.propTypes = {
    dataLists: PropTypes.object.isRequired,
    selectionAddActions: PropTypes.object.isRequired,
    filterValues: PropTypes.object.isRequired
};

export default FilterSelections;
